import {Component, OnInit} from '@angular/core';
import {ThemeService} from '../../services/theme/theme.service';
import {NavigationService} from '../../services/navigation/navigation.service';
import {RoutesEnum} from '../../services/navigation/routes.enum';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {LanguageService} from '../../services/language/language.service';
import {Utils} from '@astek/utils';
import {UserRolesEnum} from '../../services/user/user-roles.enum';
import {StateService} from '../../services/state/state.service';

type NavigationLink = {
  key: string;
  routerLink: Array<string>;
}

@Component({
  selector: 'xp-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit {

  private _navigationLinks: Array<NavigationLink> = [];

  constructor(
    private readonly _themeService: ThemeService,
    private readonly _navigationService: NavigationService,
    private readonly _authenticationService: AuthenticationService,
    private readonly _languageService: LanguageService,
    private readonly _stateService: StateService,
  ) {
  }

  public get appVersion(): string {
    return this._stateService.appVersion;
  }

  public get darkTheme(): boolean {
    return this._themeService.darkTheme;
  }

  public get logoUrl(): string {
    return this.darkTheme
      ? 'assets/images/xp-logo-teal.svg'
      : 'assets/images/xp-logo.svg';
  }

  public get isHome(): boolean {
    return this._navigationService.currentPage === RoutesEnum.HOME;
  }

  public get availableLanguages(): Array<string> {
    return this._languageService.availableLanguages;
  }

  public get activeLanguage(): string {
    return this._languageService.activeLanguage;
  }

  public get navigationLinks(): Array<NavigationLink> {
    return this._navigationLinks;
  }

  public ngOnInit(): void {
    if (Utils.isNotNullOrUndefined(this._authenticationService.user)) {
      const roles: Array<UserRolesEnum> = this._authenticationService.user.roles;
      switch (true) {
        case roles.includes(UserRolesEnum.ADMIN):
          this._navigationLinks = [
            {key: 'USERS', routerLink: ['/', RoutesEnum.USERS]},
            {key: 'SENSORS', routerLink: ['/', RoutesEnum.SENSORS]},
            {key: 'BOXES', routerLink: ['/', RoutesEnum.BOXES]},
            {key: 'SETTINGS', routerLink: ['/', RoutesEnum.SETTINGS]},
            {key: 'HEALTH_CENTERS', routerLink: ['/', RoutesEnum.HEALTH_CENTERS]},
          ];
          break;
        case roles.includes(UserRolesEnum.SUBCONTRACTOR):
          this._navigationLinks = [
            {key: 'SENSORS', routerLink: ['/', RoutesEnum.SENSORS]},
            {key: 'BOXES', routerLink: ['/', RoutesEnum.BOXES]},
          ];
          break;
        case roles.includes(UserRolesEnum.PRACTITIONER):
          this._navigationLinks = [
            {key: 'PATIENTS', routerLink: ['/', RoutesEnum.PATIENTS]},
          ];
          break;
      }
    }
  }

  public toggleDarkTheme(): void {
    this._themeService.toggleDarkTheme();
  }

  public async navigateToHome(): Promise<void> {
    await this._navigationService.navigateTo(RoutesEnum.HOME);
  }

  public logout(): void {
    this._authenticationService.logout();
  }

  public setLanguage(language: string): void {
    this._languageService.selectLanguage(language);
  }

}
